<template>
  <Modal v-model="visible" :title="title" :mask-closable="false" @on-visible-change="bindGat">
    <Form :label-width="140">
      <FormItem label="游戏组">
        <auto-complete
          v-model="gameGroupId"
          :data="groupData"
          :popper-append-to-body="false"
          style="width: 280px"
          placeholder="全部"
          @on-select="handleDataGroup"
        />
      </FormItem>
      <FormItem label="媒体">
        <Select v-model="mediaId" style="width: 120px" placeholder="请选择媒体">
          <Option :value="10">巨量引擎</Option>
          <Option :value="16">腾讯</Option>
          <Option :value="32">磁力引擎</Option>
          <Option :value="6">超级汇川</Option>
          <Option :value="45">百度信息流</Option>
        </Select>
      </FormItem>
      <FormItem label="在跑计划数 >">
        <Input v-model="planCount" placeholder="请输入整数" style="width: 100px" @on-blur="toFloat('planCount', planCount, false)" />
      </FormItem>
    </Form>
    <template slot="footer">
      <div class="m-foot">
        <Button @click="$emit('input', false)">取消</Button>
        <Button type="primary" :loading="loading" @click="ok">
          <span v-if="loading">提交中...</span>
          <span v-else>确认</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>
<script>
import { mul, div } from '@/common/js/api'
import { isEmpty, trim } from '@/common/js/utils'
import AutoComplete from '@/components/autocomplete/autocomplete'
export default {
  name: 'setRule',
  components: { AutoComplete },
  props: {
    value: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    data: {
      type: Object
    },
    editModel: {
      type: Boolean,
      default: false
    },
    groupData: {
      type: Array
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    title() {
      return this.editModel ? '修改规则' : '新建规则'
    }
  },
  data() {
    return {
      ruleId: 0,
      gameGroupId: '',
      mediaId: '',
      planCount: ''
    }
  },
  methods: {
    bindGat(val) {
      if (val && this.data && this.data.ruleId) {
        // 修改
        const { ruleId, gameGroupId, mediaId, planCount } = this.data
        this.ruleId = ruleId
        this.gameGroupId = gameGroupId
        this.mediaId = mediaId
        this.planCount = planCount
      } else {
        this.ruleId = 0
        this.gameGroupId = ''
        this.mediaId = ''
        this.planCount = ''
      }
    },
    handleDataGroup(meta) {
      this.gameGroupId = meta.id
    },
    toFloat(key, val, fixed) {
      val = trim(val)
      if (isEmpty(val)) return
      if (fixed) {
        val = parseFloat(val)
        if (!isNaN(val)) {
          val = mul(val, 100)
          val = div(Math.floor(val), 100)
        } else val = ''
      } else {
        val = parseInt(val)
        isNaN(val) && (val = '')
        val < 0 && (val = 0)
      }
      this[key] = val
    },
    ok() {
      if (isEmpty(this.gameGroupId)) {
        this.$Message.error('游戏组不能为空')
        return
      }
      if (isEmpty(this.mediaId)) {
        this.$Message.error('媒体不能为空')
        return
      }
      if (isEmpty(this.planCount)) {
        this.$Message.error('限制在跑计划数不能为空')
        return
      }
      if (!this.planCount || this.planCount > 9999999) {
        this.$Message.error('限制在跑计划数范围为：0 ~ 10000000 之间')
        return
      }
      this.$emit('on-save', {
        ruleId: this.ruleId,
        gameGroupId: this.gameGroupId,
        mediaId: this.mediaId,
        planCount: this.planCount
      })
    }
  }
}
</script>
